import { NavLink, Outlet } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { ShoppingCart } from "lucide-react";
import { Logo } from "@/components/common";
import { useMe } from "@/context/MeContext";
import { useCart } from "@/context/CartContext";
import { ROLE_LABEL } from "@/lib/labels";
import CartSheet from "@/components/CartSheet";

const LINKS = {
  customer: [
    { to: "/owner", label: "الرئيسية", end: true },
    { to: "/owner/maintenance", label: "خدمات الملاك" },
    { to: "/owner/store", label: "الخدمات الشخصية" },
    { to: "/owner/orders", label: "طلباتي" },
  ],
  employee: [{ to: "/employee", label: "مهامي", end: true }],
  admin: [{ to: "/admin", label: "لوحة الإدارة", end: true }],
};

const NavItems = ({ links }) =>
  links.map((l) => (
    <NavLink
      key={l.to}
      to={l.to}
      end={l.end}
      data-testid={`nav-${l.to.replaceAll("/", "-").slice(1)}`}
      className={({ isActive }) =>
        `whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors ${isActive ? "bg-[#C59B27] text-[#0F382C]" : "text-white/80 hover:bg-white/10 hover:text-white"}`
      }
    >
      {l.label}
    </NavLink>
  ));

export default function AppShell() {
  const { me } = useMe();
  const cart = useCart();
  const links = LINKS[me?.role] || [];
  const isOwner = me?.role === "customer" && me?.status === "approved";
  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <header className="sticky top-0 z-40 border-b border-[#164E3D] bg-[#0F382C]/95 backdrop-blur-md">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
          <Logo light />
          <nav className="hidden md:flex items-center gap-1">
            <NavItems links={links} />
          </nav>
          <div className="flex items-center gap-3">
            <span data-testid="current-role-badge" className="hidden sm:inline rounded-full bg-white/10 px-3 py-1 text-xs text-white/80">
              {ROLE_LABEL[me?.role]}
            </span>
            {isOwner && (
              <button data-testid="open-cart-button" onClick={() => cart.setOpen(true)} className="relative rounded-full bg-white/10 p-2.5 text-white hover:bg-white/20 transition-colors">
                <ShoppingCart className="h-5 w-5" />
                {cart.totals.count > 0 && (
                  <span data-testid="cart-count-badge" className="absolute -top-1 -left-1 grid h-5 min-w-5 place-items-center rounded-full bg-[#C59B27] px-1 text-[11px] font-bold text-[#0F382C]">
                    {cart.totals.count}
                  </span>
                )}
              </button>
            )}
            <div data-testid="user-menu"><UserButton /></div>
          </div>
        </div>
        {links.length > 1 && (
          <nav className="flex md:hidden gap-1 overflow-x-auto px-3 pb-3">
            <NavItems links={links} />
          </nav>
        )}
      </header>
      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 sm:py-10">
        <Outlet />
      </main>
      {isOwner && <CartSheet />}
    </div>
  );
}
